import { render } from "./icon-phone.vue?vue&type=template&id=b2f24d0e"
import script from "./icon-phone.vue?vue&type=script&lang=js"
export * from "./icon-phone.vue?vue&type=script&lang=js"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__